

angular
.module('inkfinder')
.factory('Projects', function Projects(
  $http,
  ENDPOINT,
  FormatProject,
  FormatAppointment,
  AlertMessages,
  Session,
  _) {
  // Public methods
  Projects.get = get;

  /**
   * @name getProjects
   * @description Get a collection of projects
   * @param {string} ids A string of project ids to get an array of projects.
   * @param {number} collector A collector ID to return results filtered by collector.
   * @return {array} formattedProjects Returns an array of formatted projects
   * and appointments sorted by appointment status.
   */
  function get(ids, collector) {
    let role = Session.activeState.role;
    let url = ENDPOINT.server + 'projects/api/v1.1/?role=' + role;
    if (!_.isUndefined(Session.activeState.association)) {
      let associationId = Session.activeState.association.id;
      url += '&association_id=' + associationId;
    }
    if (!_.isUndefined(ids)) {
      url += '&ids=' + ids;
    }
    if (!_.isUndefined(collector)) {
      url += '&collector_id=' + collector;
    }
    return $http.get(url)
    .then(function(response) {
      return FormatProject.formatCollection(response.data);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return Projects;
});



// WEBPACK FOOTER //
// ./components/projects/projects.service.js